export enum Partners {
  amazon = 'amazon',
  facet = 'facet',
  brCashOutRefi = 'brCashOutRefi',
  nerdwallet = 'nerdwallet',
  // Builders
  hrm = 'hrm',
  whiteTree = 'whiteTree',
  sims = 'sims',
  // Publishers
  savingsPro = 'SavingsPro',
  homeImprovementLoanPros = 'Home Improvement Loan Pros',
  fintelConnect = 'Fintel Connect',
  forbes = 'Forbes',
  militaryVALoan = 'Military VA Loan',
  theMortgageReports = 'The Mortgage Reports',
  fundCom = 'Fund.com',
  mortgageInsiders = 'Mortgage Insiders',
  findMortgages = 'FindMortgages',
  bestOnlineMortgages = 'Best Online Mortgages',
  mortgageResearchCenter = 'MortgageResearchCenter',
  bestMoneyCom = 'BestMoney.com',
  mortgageLendersComparison = 'MortgageLendersComparison',
  ownUp = 'OwnUp',
  rateZip = 'RateZip',
  realtorCom = 'Realtor.com',
}

interface PartnerCode {
  [code: string]: Partners
}

export const PartnerCodeList: PartnerCode = {
  '2f49875e': Partners.amazon,
  facet: Partners.facet,
  br439: Partners.brCashOutRefi,
  nerdwallet: Partners.nerdwallet,
  hrm: Partners.hrm,
  whiteTree: Partners.whiteTree,
  sims: Partners.sims,
  '49640': Partners.savingsPro,
  '36586': Partners.homeImprovementLoanPros,
  '50637': Partners.fintelConnect,
  '44828': Partners.forbes,
  '49937': Partners.militaryVALoan,
  '49492': Partners.theMortgageReports,
  '48756': Partners.fundCom,
  '50598': Partners.mortgageInsiders,
  '50286': Partners.findMortgages,
  '48860': Partners.bestOnlineMortgages,
  '50587': Partners.mortgageResearchCenter,
  '47109': Partners.bestMoneyCom,
  '50557': Partners.mortgageLendersComparison,
  '50597': Partners.ownUp,
  '48731': Partners.rateZip,
  '50107': Partners.realtorCom,
  '11114': Partners.mortgageResearchCenter, // MRC Purchase CPC
  '11115': Partners.mortgageResearchCenter, // MRC Premium Purchase CPC
  '11116': Partners.mortgageResearchCenter, // MRC Refinance CPC
  '11117': Partners.mortgageResearchCenter, // MRC Premium Refinance CPC
}
